/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPlus: {
  name: 'plus';
  data: string;
} = {
  name: 'plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 1a.5.5 0 0 0-1 0v6.5H1a.5.5 0 0 0 0 1h6.5V15a.5.5 0 0 0 1 0V8.5H15a.5.5 0 0 0 0-1H8.5V1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
